(() => {
  if (window.cvPackageToolsLoaded) return;
  window.cvPackageToolsLoaded = true;
  const voltageValues = ['110V', '220V'];
  const laserValues = ['20W', '30W', '50W 3D', '60W MOPA'];
  const variants = (card) => {
    try { return JSON.parse(card.querySelector('[data-package-variants]')?.textContent || '[]'); }
    catch (_) { return []; }
  };
  const indexOfKind = (data, values) => {
    const length = data[0]?.options?.length || 0;
    for (let i = 0; i < length; i++) {
      const found = [...new Set(data.map((variant) => variant.options[i]))];
      if (found.length && found.every((value) => values.includes(value))) return i;
    }
    return -1;
  };
  const resolve = (data, options) => data.find((variant) => variant.options.length === options.length && variant.options.every((value, index) => value === options[index]));
  const imageFor = (variant, card) => {
    const media = variant?.featured_media?.preview_image;
    const image = media || variant?.featured_image;
    const url = typeof image === 'string' ? image : image?.src || image?.url;
    return url || card.dataset.packageImageUrl || '';
  };
  const sized = (source, width) => {
    if (!source) return '';
    try { const url = new URL(source, location.href); url.searchParams.set('width', String(width)); return url.toString(); }
    catch (_) { return source; }
  };
  const init = (root, attempt = 0) => {
    if (root.cvToolsCleanup || !root.isConnected) return;
    if (!root.cvPackageSelect) {
      if (attempt < 8) requestAnimationFrame(() => init(root, attempt + 1));
      return;
    }
    const cards = [...root.querySelectorAll('[data-package]')];
    const main = cards.find((card) => card.dataset.packageStandalone === 'true');
    if (!main || !cards.length) return;
    const abort = new AbortController(), events = { signal: abort.signal };
    const dialog = root.querySelector('[data-cv-package-dialog]');
    const large = dialog?.querySelector('[data-cv-large-image]');
    const viewer = dialog?.querySelector('[data-cv-image-viewer]');
    const closeButton = dialog?.querySelector('[data-cv-image-close]');
    const title = dialog?.querySelector('[data-cv-image-title]');
    const prefix = root.hasAttribute('data-z12cx-product') ? 'z12' : 'cv';
    const params = new URL(location.href).searchParams;
    let selected = cards.find((card) => card.dataset.productId === params.get(prefix + '_package')) || cards.find((card) => card.classList.contains('is-selected')) || main;
    const data = new Map(cards.map((card) => [card, variants(card)]));
    const c1StableVoltage = prefix === 'cv' && main.dataset.productId === '10211210494267';
    const indices = new Map(cards.map((card) => [card, {
      voltage: c1StableVoltage ? (data.get(card).find(variant => voltageValues.includes(variant.cv_voltage) && Number.isInteger(variant.cv_voltage_option))?.cv_voltage_option ?? -1) : indexOfKind(data.get(card), voltageValues),
      laser: indexOfKind(data.get(card), laserValues)
    }]));
    const resolveCard = (card, options) => {
      const variant = resolve(data.get(card), options);
      return c1StableVoltage && variant?.cv_voltage !== voltage ? undefined : variant;
    };
    let initial = data.get(selected).find((variant) => String(variant.id) === params.get(prefix + '_variant'))
      || data.get(selected).find((variant) => String(variant.id) === root.querySelector('[data-main-variant-input]')?.value)
      || data.get(selected).find((variant) => String(variant.id) === selected.dataset.variantId)
      || data.get(selected)[0];
    const first = indices.get(selected);
    let voltage = c1StableVoltage ? (initial?.cv_voltage || '') : (initial?.options[first.voltage] || voltageValues[0]);
    let laser = first.laser < 0 ? '' : initial?.options[first.laser] || laserValues[0];
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'cv-voltage';
    const legend = document.createElement('legend'); legend.textContent = root.dataset.cvVoltageLabel || 'Voltage'; fieldset.append(legend);
    const choices = document.createElement('div'); choices.className = 'cv-voltage__choices'; fieldset.append(choices);
    voltageValues.forEach((value) => {
      const label = document.createElement('label'), input = document.createElement('input');
      input.type = 'radio'; input.name = 'cv-voltage-' + root.dataset.sectionId; input.value = value;
      input.dataset.cvVoltage = ''; input.checked = value === voltage;
      label.append(input, document.createTextNode(value)); choices.append(label);
    });
    const heading = root.querySelector('.cx-config-heading');
    if (!heading) return;
    heading.before(fieldset);
    let opener = null, savedScroll = null, zoom = 1;
    const close = (restore = true) => {
      if (dialog?.open) dialog.close();
      if (restore && opener?.isConnected) opener.focus({ preventScroll: true });
      if (restore && savedScroll && (Math.abs(scrollY - savedScroll.y) > 1 || Math.abs(scrollX - savedScroll.x) > 1)) window.scrollTo({ left: savedScroll.x, top: savedScroll.y, behavior: 'instant' });
      opener = null; savedScroll = null;
    };
    const open = (button, card) => {
      const source = button.dataset.cvFullImage;
      if (!source || !dialog || !large || !dialog.showModal) return;
      opener = button; savedScroll = { x: scrollX, y: scrollY }; zoom = 1;
      large.style.width = '100%'; large.style.maxWidth = '100%';
      large.src = source; large.alt = card.querySelector('.cx-package__copy strong')?.textContent.trim() || '';
      title.textContent = large.alt; dialog.showModal(); viewer.scrollTo(0, 0); closeButton.focus({ preventScroll: true });
    };
    closeButton?.addEventListener('click', () => close(), events);
    dialog?.addEventListener('cancel', (event) => { event.preventDefault(); close(); }, events);
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) close(); }, events);
    const setZoom = (delta) => {
      zoom = Math.max(1, Math.min(3, zoom + delta));
      large.style.width = (zoom * 100) + '%'; large.style.maxWidth = 'none';
    };
    dialog?.querySelector('[data-cv-zoom-in]')?.addEventListener('click', () => setZoom(.5), events);
    dialog?.querySelector('[data-cv-zoom-out]')?.addEventListener('click', () => setZoom(-.5), events);
    const cardOptions = (card) => {
      const options = [...card.querySelectorAll('[data-package-option]')].map((select) => select.value);
      const index = indices.get(card);
      if (index.voltage >= 0) {
        if (c1StableVoltage) {
          const matching = data.get(card).find(variant => variant.cv_voltage === voltage && variant.options.every((value, position) => position === index.voltage || value === options[position]));
          options[index.voltage] = matching?.options[index.voltage] || '';
        } else options[index.voltage] = voltage;
      }
      if (index.laser >= 0 && laser) options[index.laser] = laser;
      return options;
    };
    const updateCards = () => {
      cards.forEach((card) => {
        const options = cardOptions(card), variant = resolveCard(card, options);
        card.querySelectorAll('[data-package-option]').forEach((select, index) => { select.value = options[index] || ''; });
        const choice = card.querySelector('[data-cv-package-choice]');
        choice.checked = card === selected; choice.disabled = !variant?.available;
        card.setAttribute('aria-disabled', String(!variant?.available));
        const note = card.querySelector('[data-cv-package-note]');
        note.hidden = !!variant?.available;
        note.textContent = variant?.available ? '' : (variant ? root.dataset.soldOutLabel : root.dataset.unavailableLabel);
        const source = imageFor(variant, card), button = card.querySelector('[data-cv-package-zoom]'), image = button?.querySelector('img');
        if (image && source) {
          image.src = sized(source, 384);
          image.srcset = [96, 192, 384].map((width) => sized(source, width) + ' ' + width + 'w').join(', ');
          image.sizes = '(max-width: 749px) 96px, 84px';
          button.dataset.cvFullImage = sized(source, 1800);
        }
        if (!variant) {
          const price = card.querySelector('[data-package-price]');
          if (price) price.textContent = root.dataset.unavailableLabel || '';
        }
        if (variant) {
          const format = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
          const price = card.querySelector('[data-package-price]');
          if (price) price.textContent = format.format(Number(variant.price) / 100);
          const compare = card.querySelector('[data-package-compare]');
          if (compare) { compare.textContent = format.format(Number(variant.compare_at_price || 0) / 100); compare.hidden = !(variant.compare_at_price > variant.price) || root.dataset.hideCompare === 'true'; }
        }
        if (root.hasAttribute('data-z12cx-product')) {
          const saving = card.querySelector('[data-package-saving]');
          const onSale = root.dataset.hideCompare !== 'true' && variant?.compare_at_price > variant?.price;
          if (saving) {
            saving.hidden = !onSale;
            const amount = saving.querySelector('span');
            if (amount) amount.textContent = onSale ? new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }).format((variant.compare_at_price - variant.price) / 100) : '';
          }
        }
      });
    };
    const syncURL = (card, variant) => {
      const url = new URL(location.href);
      const base = variant && resolveCard(main, cardOptions(main));
      if (base) url.searchParams.set('variant', String(base.id)); else url.searchParams.delete('variant');
      if (variant && card !== main) {
        url.searchParams.set(prefix + '_package', card.dataset.productId);
        url.searchParams.set(prefix + '_variant', String(variant.id));
      } else {
        url.searchParams.delete(prefix + '_package'); url.searchParams.delete(prefix + '_variant');
      }
      history.replaceState(null, '', url.toString());
    };
    const apply = (card, updateURL = true) => {
      selected = card;
      updateCards();
      const variant = resolveCard(card, cardOptions(card));
      root.cvPackageSelect(card, variant);
      cards.forEach((item) => { item.removeAttribute('aria-checked'); item.querySelector('[data-cv-package-choice]').checked = item === card; });
      if (updateURL) syncURL(card, variant);
    };
    cards.forEach((card, index) => {
      card.setAttribute('role', 'group'); card.removeAttribute('tabindex'); card.removeAttribute('aria-checked');
      const heading = card.querySelector('.cx-package__copy strong');
      card.setAttribute('aria-label', heading?.textContent.trim() || String(index + 1));
      const choice = document.createElement('input');
      choice.type = 'radio'; choice.className = 'cv-package-choice'; choice.name = 'cv-package-' + root.dataset.sectionId;
      choice.value = card.dataset.productId; choice.dataset.cvPackageChoice = '';
      choice.setAttribute('aria-label', heading?.textContent.trim() || String(index + 1));
      heading.before(choice);
      const note = document.createElement('span'); note.className = 'cv-package-unavailable'; note.dataset.cvPackageNote = ''; note.hidden = true;
      card.append(note);
      card.querySelectorAll('[data-package-option]').forEach((select, optionIndex) => {
        if (optionIndex === indices.get(card).voltage) select.closest('label').dataset.cvVoltageOption = '';
      });
    });
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-cv-package-dialog]')) return;
      const button = event.target.closest('[data-cv-package-zoom]');
      if (button) { event.preventDefault(); event.stopImmediatePropagation(); open(button, button.closest('[data-package]')); return; }
      const card = event.target.closest('[data-package]');
      if (!card || event.target.closest('select,[data-package-includes]')) return;
      event.stopImmediatePropagation();
      const variant = resolveCard(card, cardOptions(card));
      if (variant?.available) apply(card);
    }, { ...events, capture: true });
    root.addEventListener('keydown', (event) => {
      if (event.target.closest('[data-cv-package-zoom],[data-cv-package-choice]')) event.stopPropagation();
    }, { ...events, capture: true });
    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-cv-voltage]')) {
        event.stopImmediatePropagation(); voltage = event.target.value; apply(selected); return;
      }
      const card = event.target.closest('[data-package]');
      if (!card) return;
      if (event.target.matches('[data-cv-package-choice]')) { event.stopImmediatePropagation(); apply(card); return; }
      if (!event.target.matches('[data-package-option]')) return;
      event.stopImmediatePropagation();
      const position = [...card.querySelectorAll('[data-package-option]')].indexOf(event.target);
      if (position === indices.get(card).laser) laser = event.target.value;
      apply(card);
    }, { ...events, capture: true });
    root.cvToolsCleanup = () => {
      close(false); abort.abort(); fieldset.remove();
      cards.forEach((card) => {
        card.querySelector('[data-cv-package-choice]')?.remove();
        card.querySelector('[data-cv-package-note]')?.remove();
        card.querySelectorAll('[data-cv-voltage-option]').forEach((label) => label.removeAttribute('data-cv-voltage-option'));
        card.setAttribute('role', 'radio'); card.setAttribute('tabindex', '0');
        card.setAttribute('aria-checked', String(card.classList.contains('is-selected')));
        card.removeAttribute('aria-disabled');
      });
      root.removeAttribute('data-cv-tools-ready');
      large?.removeAttribute('src');
      delete root.cvToolsCleanup;
    };
    root.setAttribute('data-cv-tools-ready', '');
    apply(selected, false);
  };
  const boot = (scope = document) => {
    if (scope.matches?.('[data-cv-package-tools]')) init(scope);
    scope.querySelectorAll('[data-cv-package-tools]').forEach((root) => init(root));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot(), { once: true }) : boot();
  document.addEventListener('shopify:section:load', (event) => queueMicrotask(() => boot(event.target)));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-cv-package-tools]').forEach((root) => root.cvToolsCleanup?.()));
})();
